import z from 'zod';
import { zoneRef, assetGroupRef } from './refs';
import { schedule } from './schedule';
import { datetime, url } from './zod';
export var KioskConfigAlarmMode;
(function (KioskConfigAlarmMode) {
    KioskConfigAlarmMode["ZoneBased"] = "zoneBased";
    KioskConfigAlarmMode["CustomerBased"] = "customerBased";
})(KioskConfigAlarmMode || (KioskConfigAlarmMode = {}));
export const kioskIncidentCounterConfig = z.object({
    enabled: z.boolean().default(true),
    countFromDate: datetime.nullable(),
    threshold: z.number().min(0).default(0),
});
export const kioskHomepageConfig = z.object({
    incidentCounter: kioskIncidentCounterConfig,
    anonymous: z.boolean().default(true),
    logo: url.nullable(),
    // Filters out assets that are not inside the zones
    assetInsideZones: zoneRef.array().optional(),
});
export const kioskAlarmAcknowledgeConfig = z.object({
    enabled: z.boolean().default(true),
    pin: z.string().regex(/^[0-9]{4,6}$/).nullable(),
    messagePresets: z.string().array().nullish(),
});
export const kioskAlarmConfig = z.object({
    enabled: z.boolean().default(true),
    audio: z.boolean().default(true),
    flash: z.boolean().default(true),
    showPositionLabels: z.boolean().default(true),
    anonymous: z.boolean().default(true),
    acknowledge: kioskAlarmAcknowledgeConfig.optional(),
    mode: z.nativeEnum(KioskConfigAlarmMode).optional(),
});
export const kioskAvailabilityConfig = z.object({
    enabled: z.boolean().default(true),
    pin: z.string().regex(/^[0-9]{4,6}$/).nullable(),
    showAppBanner: z.boolean().default(true),
    forceShowSearch: z.boolean().default(false),
    forceShowLabelFilter: z.boolean().default(false),
});
export const kioskHardwareConfig = z.object({
    screenBrightness: z.number().min(0).max(100).nullable(),
});
export const kioskConfigOutput = z.object({
    managed: z.boolean().default(false),
    zone: zoneRef.nullable(),
    exposeAssets: assetGroupRef.array(),
    exposeLabels: assetGroupRef.array(),
    countAssets: assetGroupRef.array(),
    schedule: schedule.nullable(),
    homepage: kioskHomepageConfig,
    alarm: kioskAlarmConfig,
    manageAvailability: kioskAvailabilityConfig,
    hardware: kioskHardwareConfig.optional(),
});
export const kioskConfig = kioskConfigOutput.partial();
export const defaultKioskConfig = kioskConfigOutput.omit({
    zone: true,
});
